
    import { Component, Vue } from 'vue-facing-decorator';
    import { Getter } from '@/plugins/vuex-decorators';
    import Error from '@/components/Error.vue';
    import BusyLogo from '@/components/BusyLogo.vue';
    import ConfirmDialog from '@/components/ConfirmDialog.vue';
    @Component({
        components: {
            Error,
            ConfirmDialog,
            BusyLogo,
        },
    })
    export default class App extends Vue {
        
        @Getter('getBusy') busy!: number;
        @Getter('getDatabaseStatus') databaseStatus!: number;
        @Getter('getError') error!: any;
        @Getter('getEnvironment') environment!: any;
        @Getter('getVersion') version!: any;
        @Getter('getUser') user!: any;
        @Getter('getInProgress') inProgress!: number;
        
        updateStatus(disabled: any) {
            alert(disabled);
        }
    }
